import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";
import _ from "lodash";

import { Translate, I18n } from "react-redux-i18n";

import Modal from "react-bootstrap/Modal";
import Dropdown from "react-bootstrap/Dropdown";
import ButtonGroup from "react-bootstrap/ButtonGroup";

import { setAlert } from "../../../actions/alertActions";
import { getPlug } from "../../utils/Utils";

import "../../../styles/components/chargers/modals/PlugInfo.scss";
import tariff_mini from "../../../styles/images/tariff_mini.svg";
import availability_mini from "../../../styles/images/availability_mini.svg";
import access_mini from "../../../styles/images/access_mini.svg";
import public_access from "../../../styles/images/public_access_white.svg";
import arrow from "../../../styles/images/arrow_black.svg";
import pencil from "../../../styles/images/pencil.svg";

class PlugInfo extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      tabIndex: 0,

      selectedCharger: null,
      selectedPlug: null,
      tariffs: [],
      purchaseTariffs: [],
      groupsUserIsIn: [],
    };

    this.handleOnChangePurchaseTariff =
      this.handleOnChangePurchaseTariff.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    if (this.props.includeTariff) {
      this.fetchTariffs();
      this.fetchPurchaseTariffs();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.hasOwnProperty("selectedCharger") &&
      this.props.selectedCharger
    )
      if (
        prevProps.selectedCharger !== this.props.selectedCharger ||
        prevProps.selectedCharger._id !== this.props.selectedCharger._id
      )
        this.safeSetState(
          {
            selectedCharger: this.props.selectedCharger,
          },
          () => this.handleGroupsUserHaveAccessTo()
        );

    if (this.props.hasOwnProperty("selectedPlug") && this.props.selectedPlug)
      if (
        prevProps.selectedPlug !== this.props.selectedPlug ||
        prevProps.selectedPlug.plugId !== this.props.selectedPlug.plugId
      )
        this.safeSetState({ selectedPlug: this.props.selectedPlug });

    if (
      this.props.hasOwnProperty("tabIndex") &&
      !Number.isNaN(this.props.tabIndex)
    )
      if (prevState.tabIndex !== this.props.tabIndex)
        this.safeSetState({ tabIndex: this.props.tabIndex });
  }

  /*
    This function is responsible for checking from all the groups a charger is shared with, which groups the logged in user has access to. 
    This is important because it avois displaying private information about other groups tariffs
  */
  handleGroupsUserHaveAccessTo() {
    let groupsUserIsIn = [];
    const groups = this.state.selectedCharger?.listOfGroups;
      groups?.forEach((group) => {
          group?.listOfUsers?.forEach((user) => {
            if (user?.userId === this.props.accountData?.id) {
              groupsUserIsIn.push(group);
            }
          });
      });

    this.safeSetState({
      groupsUserIsIn: groupsUserIsIn,
    });
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this.cancel) this.cancel("Component is unmounting");
  }

  fetchTariffs() {
    axios
      .get("/api/private/salesTariff", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        this.safeSetState({ tariffs: res.data });
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  fetchPurchaseTariffs() {
    axios
      .get("/api/private/purchaseTariff", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        this.safeSetState({ purchaseTariffs: res.data });
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  persistPlug() {
    const patch = {
      _id: this.state.selectedCharger.chargerId,
      plugId: this.state.selectedPlug.plugId,
      tariff: this.state.selectedPlug.tariff,
    };
    axios
      .patch("/api/private/chargers/tariffs", patch, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t("plugInfo_success"), "primary");
        }
      })
      .catch((err) => {
        if (err.response && err.response.data)
          this.props.setAlert(I18n.t(err.response.data.message), "danger");
        if (axios.isCancel(err)) console.log("axios", err);
        else console.log(err);
      });
  }

  handleOnChangePurchaseTariff(e) {
    const idx = e.target.value;
    const purchaseTariff = this.state.purchaseTariffs[idx];
    const patch = {
      _id: this.state.selectedCharger.chargerId,
      purchaseTariff,
    };

    axios
      .patch("/api/private/chargers/addPurchaseTariff", patch, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t("plugInfo_success"), "primary");
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  getPurchaseTariffDefaultValue() {
    const idx = this.state.purchaseTariffs.findIndex(
      (pt) => pt._id === this.state.selectedCharger.purchaseTariff?._id
    );

    return idx !== -1 ? idx : "";
  }

  checkTariff(plug) {
    if (!plug.tariff.length > 0) {
      return false;
    }

    let bool = true;

    plug.tariff.forEach((p) => {
      if (
        !(
          (p.tariffType &&
            p.groupName &&
            p.tariff &&
            p.name &&
            p.name !== "" &&
            p.tariffType !== "" &&
            p.groupName !== "" &&
            p.tariffType !== "Unknown") ||
          p.fleetId
        )
      ) {
        bool = false;
      }
    });
    return bool;
  }

  checkPlug(p) {
    return (
      p.connectorType &&
      p.amperage &&
      p.power &&
      p.voltage &&
      p.active &&
      p.connectorType !== "" &&
      p.amperage !== "" &&
      p.power !== "" &&
      p.voltage !== "" &&
      p.active !== "" &&
      p.connectorType !== "Unknown"
    );
  }

  handleOnClick(e, idx) {
    this.safeSetState({
      tabIndex: !Number.isNaN(idx) ? idx : 1,
    });
  }

  handleOnSelect(key, e, g) {
    this.safeSetState(
      (prevState) => {
        //If g is undefined, it means the tariff is public
        if (g) {
          const idx = prevState.selectedPlug.tariff.findIndex(
            (t) => t.groupId === g.groupId
          );
          const newTariff = this.state.tariffs.find((t) => t._id === key);

          return {
            selectedPlug: Object.assign(prevState.selectedPlug, {
              tariff: [
                ...prevState.selectedPlug.tariff.slice(0, idx),
                {
                  tariffId: key,
                  groupName: g.name,
                  groupId: g.groupId,
                  name: newTariff.name,
                  tariff: newTariff.tariff,
                  tariffType: newTariff.tariffType,
                },
                ...prevState.selectedPlug.tariff.slice(idx + 1),
              ],
            }),
          };
        } else {
          const idx = prevState.selectedPlug.tariff.findIndex(
            (t) => t.groupName === "Public"
          );
          const newTariff = this.state.tariffs.find((t) => t._id === key);
          return {
            selectedPlug: Object.assign(prevState.selectedPlug, {
              tariff: [
                ...prevState.selectedPlug.tariff.slice(0, idx),
                {
                  tariffId: key,
                  groupName: "Public",
                  groupId: "",
                  name: newTariff.name,
                  tariff: newTariff.tariff,
                  tariffType: newTariff.tariffType,
                },
                ...prevState.selectedPlug.tariff.slice(idx + 1),
              ],
            }),
          };
        }
      },
      () => this.persistPlug()
    );
  }

  handleOnSelectFleet(key, e, g) {
    this.safeSetState(
      (prevState) => {
        //If g is undefined, it means the tariff is public
        if (g) {
          const idx = prevState.selectedPlug.tariff.findIndex(
            (t) => t.fleetId === g.fleetId
          );
          const newTariff = this.state.tariffs.find((t) => t._id === key);

          return {
            selectedPlug: Object.assign(prevState.selectedPlug, {
              tariff: [
                ...prevState.selectedPlug.tariff.slice(0, idx),
                {
                  tariffId: key,
                  fleetName: g.fleetName,
                  fleetId: g.fleetId,
                  name: newTariff.name,
                  tariff: newTariff.tariff,
                  tariffType: newTariff.tariffType,
                },
                ...prevState.selectedPlug.tariff.slice(idx + 1),
              ],
            }),
          };
        } else {
          const idx = prevState.selectedPlug.tariff.findIndex(
            (t) => t.groupName === "Public"
          );
          const newTariff = this.state.tariffs.find((t) => t._id === key);
          return {
            selectedPlug: Object.assign(prevState.selectedPlug, {
              tariff: [
                ...prevState.selectedPlug.tariff.slice(0, idx),
                {
                  tariffId: key,
                  groupName: "Public",
                  groupId: "",
                  name: newTariff.name,
                  tariff: newTariff.tariff,
                  tariffType: newTariff.tariffType,
                },
                ...prevState.selectedPlug.tariff.slice(idx + 1),
              ],
            }),
          };
        }
      },
      () => this.persistPlug()
    );
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    let fleetIndex = 0;
    let groupIndex = 0;

    return (
      <>
        <Modal
          id="plugInfo"
          show={this.props.show}
          onHide={this.props.onHide}
          centered
        >
          <Modal.Header>
            {this.props.hasOwnProperty("includeTariff") &&
            this.state.selectedPlug &&
            this.checkPlug(this.state.selectedPlug) &&
            this.checkTariff(this.state.selectedPlug) ? (
              <div className="tabs toggle">
                <p
                  className={this.state.tabIndex === 0 ? "selected" : ""}
                  onClick={(e) => this.handleOnClick(e, 0)}
                >
                  <Translate value="plugInfo_info" />
                </p>

                <p
                  className={this.state.tabIndex === 1 ? "selected" : ""}
                  onClick={(e) => this.handleOnClick(e, 1)}
                >
                  <Translate value="plugInfo_tariff" />
                </p>
              </div>
            ) : (
              <Modal.Title>
                <Translate value="chargers_configurePlug_consultTariff" />
              </Modal.Title>
            )}
          </Modal.Header>
          <Modal.Body>
            {this.state.tabIndex === 0 && (
              <div id="plugInfo">
                <div className="info-line">
                  <div id="plugType">
                    <p className="title">
                      <Translate value="plugInfo_connectorType" />
                    </p>
                    <p>
                      {this.state.selectedPlug &&
                        this.state.selectedPlug.connectorType}
                    </p>
                    {this.state.selectedPlug && (
                      <>
                        {this.state.selectedCharger.createUser &&
                          this.state.selectedCharger.createUser ===
                            this.props.accountData.id && (
                            <button
                              type="button"
                              className="clear"
                              onClick={(e) => {
                                e.stopPropagation();
                                this.props.setModal(
                                  "configurePlugs",
                                  true,
                                  () => this.props.onHide()
                                );
                              }}
                            >
                              <img src={pencil} alt="edit" />
                            </button>
                          )}
                        <img
                          src={
                            getPlug(this.state.selectedPlug.connectorType)
                              .borderless
                          }
                          alt=""
                        />
                      </>
                    )}
                  </div>
                </div>
                <div className="info-line">
                  <div id="plugStats">
                    <p className="title">
                      <Translate value="plugInfo_current" />
                    </p>
                    <p>
                      {this.state.selectedPlug &&
                        this.state.selectedPlug.amperage}
                    </p>
                    <p className="title">
                      <Translate value="plugInfo_voltage" />
                    </p>
                    <p>
                      {this.state.selectedPlug &&
                        this.state.selectedPlug.voltage}
                    </p>
                    <p className="title">
                      <Translate value="plugInfo_power" />
                    </p>
                    <p>
                      {this.state.selectedPlug && this.state.selectedPlug.power}
                    </p>
                  </div>
                </div>
                <div className="info-line">
                  <div id="plugTariffs" className="block">
                    {this.state.selectedPlug &&
                      this.state.selectedPlug.tariff.map(
                        (t) =>
                          (this.state.selectedCharger.createUser ===
                          this.props.accountData.id
                            ? true
                            : this.state.groupsUserIsIn.findIndex(
                                (group) => group.groupId === t.groupId
                              ) !== -1) && (
                            <React.Fragment key={t._id}>
                              <div className="group-title">
                                {t.groupName ? (
                                  <>
                                    <div className="title">{t.groupName}</div>
                                    <Translate value="plugInfo_groupTitle_title" />
                                  </>
                                ) : (
                                  <>
                                    <div className="title">{t.fleetName}</div>
                                    <Translate value="plugInfo_fleetTitle_title" />
                                  </>
                                )}
                              </div>
                              <div key={t._id} className="grid">
                                <div className="tariff-header">
                                  <img src={tariff_mini} alt="" />
                                  <p className="big title">{t.name}</p>
                                  <p className="big evio title">
                                    {t.tariffType && t.tariffType !== "" ? (
                                      <Translate
                                        value={
                                          "plugInfo_" +
                                          _.camelCase(
                                            t.tariffType.replace(" ", "")
                                          )
                                        }
                                      />
                                    ) : (
                                      <Translate value="plugInfo_tariff_notConfigured" />
                                    )}
                                  </p>
                                </div>
                                <div className="tariff-body">
                                  <p className="title">
                                    <Translate value="plugInfo_booking" />
                                  </p>
                                  <p>
                                    {t?.tariff?.bookingAmount ? (
                                      (t?.tariff?.bookingAmount?.value ?? "- ") +
                                      this.props?.preferences?.currency +
                                      (t?.tariff?.bookingAmount?.uom
                                        ? " / " + t?.tariff?.bookingAmount?.uom
                                        : "")
                                    ) : (
                                      <Translate value="plugInfo_tariff_notConfigured" />
                                    )}
                                  </p>
                                  <p className="title">
                                    <Translate value="plugInfo_charging" />
                                  </p>
                                  <p>
                                    {t?.tariff?.chargingAmount &&
                                    t?.tariff?.chargingAmount?.value >= 0 ? (
                                      `${
                                        t.tariff.chargingAmount.value +
                                        this.props.preferences.currency
                                      } / ${t.tariff.chargingAmount.uom}`
                                    ) : (
                                      <Translate value="plugInfo_tariff_notConfigured" />
                                    )}
                                  </p>
                                  <p className="title">
                                    <Translate value="plugInfo_parking" />
                                  </p>
                                  <p>
                                    {t?.tariff?.parkingAmount &&
                                    t?.tariff?.parkingAmount?.value >= 0 ? (
                                      `${
                                        t?.tariff?.parkingAmount?.value +
                                        this.props.preferences.currency
                                      } / ${t?.tariff?.parkingAmount?.uom}`
                                    ) : (
                                      <Translate value="plugInfo_tariff_notConfigured" />
                                    )}
                                  </p>
                                </div>
                              </div>
                              </React.Fragment>
                          )
                      )}
                  </div>
                </div>

                <div className="info-line">
                  <div id="plugAvailability" className="block">
                    <div className="grid">
                      <div className="availability-header">
                        <img src={availability_mini} alt="" />
                        <p className="big title">
                          <Translate value="plugInfo_availability" />
                        </p>
                        <p className="big evio title">
                          {this.state.selectedCharger && (
                            <Translate
                              value={
                                "plugInfo_" +
                                this.state.selectedCharger?.availability?.availabilityType.toLowerCase()
                              }
                            />
                          )}
                        </p>
                      </div>
                      <div className="availability-body">
                        <p className="title">
                          {this.state.selectedCharger &&
                            this.state.selectedCharger?.availability?.availabilityType}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="info-line">
                  <div id="plugAccess" className="block">
                    <div className="grid">
                      <div className="access-header">
                        <img src={access_mini} alt="" />
                        <p className="big title">
                          <Translate value="plugInfo_access" />
                        </p>
                        <p className="big evio title">
                          {this.state.selectedCharger && (
                            <Translate
                              value={
                                "plugInfo_" +
                                this.state.selectedCharger.accessType.toLowerCase()
                              }
                            />
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.props.hasOwnProperty("includeTariff") &&
              this.state.tabIndex === 1 && (
                <div id="tariffInfo">
                  <div className="tariff-list">
                    {this.state.selectedPlug?.tariff.length > 0 ? (
                      this.state.selectedPlug?.tariff.map((t, i) => {
                        const group =
                          this.state.selectedCharger.listOfGroups.find(
                            (g) => g.groupId === t.groupId
                          );
                        const fleet =
                          this.state.selectedCharger.listOfFleets.find(
                            (g) => g.fleetId === t.fleetId
                          );
                        if (!t.fleetId) {
                          groupIndex += 1;
                          return (
                            <React.Fragment
                              key={`${t.groupId || "public"}-${t.fleetId || "no-fleet"}-${i}`}
                            >
                              {groupIndex === 1 && (
                                <div className="fleet-title">
                                  <Translate value="plugInfo_groupTitle" />
                                </div>
                              )}
                              <div key={i} className="tariff-container">
                                <img
                                  src={
                                    t.groupId === ""
                                      ? public_access
                                      : (group && group.imageContent) || ""
                                  }
                                  alt=""
                                />
                                <p className="title">
                                  {t.groupName === "Public" ? (
                                    <Translate value="plugInfo_publicGroup" />
                                  ) : (
                                    t.groupName
                                  )}
                                </p>
                                <Dropdown as={ButtonGroup}>
                                  <Dropdown.Toggle id={t.groupName}>
                                    {t.name || "-"}
                                    <img src={arrow} alt="" />
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                    {this.state.tariffs.map((tariff, idx) => (
                                      <Dropdown.Item
                                        as={"div"}
                                        key={tariff._id}
                                        eventKey={tariff._id}
                                        className="tariff-info"
                                        onSelect={(key, e) =>
                                          this.handleOnSelect(key, e, group)
                                        }
                                      >
                                        <div className="tariff-header">
                                          <img src={tariff_mini} alt="" />
                                          <p className="big title">
                                            {tariff.name}
                                          </p>
                                        </div>
                                        <div className="tariff-body">
                                          <p className="title">
                                            <Translate value="plugInfo_booking" />
                                          </p>
                                          <p>
                                            {(tariff.tariff.bookingAmount
                                              .value ?? "- ") +
                                              this.props.preferences.currency +
                                              (tariff.tariff.bookingAmount.uom
                                                ? " / " +
                                                  tariff.tariff.bookingAmount
                                                    .uom
                                                : "")}
                                          </p>
                                          <p className="title">
                                            <Translate value="plugInfo_charging" />
                                          </p>
                                          <p>{`${
                                            tariff.tariff.chargingAmount.value +
                                            this.props.preferences.currency
                                          } / ${
                                            tariff.tariff.chargingAmount.uom
                                          }`}</p>
                                          <p className="title">
                                            <Translate value="plugInfo_parking" />
                                          </p>
                                          <p>{`${
                                            tariff.tariff.parkingAmount.value +
                                            this.props.preferences.currency
                                          } / ${
                                            tariff.tariff.parkingAmount.uom
                                          }`}</p>
                                        </div>

                                        <div className="tarrif-billingType">
                                          <Translate
                                            value={
                                              "addTariff_" + tariff.billingType
                                            }
                                          />
                                        </div>
                                      </Dropdown.Item>
                                    ))}
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                              </React.Fragment>
                          );
                        } else {
                          fleetIndex += 1;
                          return (
                            <React.Fragment
                              key={`${t.groupId || "public"}-${t.fleetId || "no-fleet"}-${i}`}
                            >
                              {fleetIndex === 1 && (
                                <div className="fleet-title">
                                  <Translate value="plugInfo_fleetTitle" />
                                </div>
                              )}
                              <div key={i} className="tariff-container">
                                <img src={t.imageContent} alt="" />
                                <p className="title">
                                  {t.groupName === "Public" ? (
                                    <Translate value="plugInfo_publicGroup" />
                                  ) : (
                                    t.fleetName
                                  )}
                                </p>
                                <Dropdown as={ButtonGroup}>
                                  <Dropdown.Toggle id={t.fleetName}>
                                    {t.name || "-"}
                                    <img src={arrow} alt="" />
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                    {this.state.tariffs.map((tariff, idx) => (
                                      <Dropdown.Item
                                        as={"div"}
                                        key={tariff._id}
                                        eventKey={tariff._id}
                                        className="tariff-info"
                                        onSelect={(key, e) =>
                                          this.handleOnSelectFleet(
                                            key,
                                            e,
                                            fleet
                                          )
                                        }
                                      >
                                        <div className="tariff-header">
                                          <img src={tariff_mini} alt="" />
                                          <p className="big title">
                                            {tariff.name}
                                          </p>
                                        </div>
                                        <div className="tariff-body">
                                          <p className="title">
                                            <Translate value="plugInfo_booking" />
                                          </p>
                                          <p>
                                            {(tariff.tariff.bookingAmount
                                              .value ?? "- ") +
                                              this.props.preferences.currency +
                                              (tariff.tariff.bookingAmount.uom
                                                ? " / " +
                                                  tariff.tariff.bookingAmount
                                                    .uom
                                                : "")}
                                          </p>
                                          <p className="title">
                                            <Translate value="plugInfo_charging" />
                                          </p>
                                          <p>{`${
                                            tariff.tariff.chargingAmount.value +
                                            this.props.preferences.currency
                                          } / ${
                                            tariff.tariff.chargingAmount.uom
                                          }`}</p>
                                          <p className="title">
                                            <Translate value="plugInfo_parking" />
                                          </p>
                                          <p>{`${
                                            tariff.tariff.chargingAmount.value +
                                            this.props.preferences.currency
                                          } / ${
                                            tariff.tariff.chargingAmount.uom
                                          }`}</p>
                                        </div>
                                        <div className="tarrif-billingType">
                                          <Translate
                                            value={
                                              "addTariff_" + tariff.billingType
                                            }
                                          />
                                        </div>
                                      </Dropdown.Item>
                                    ))}
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </React.Fragment>
                          );
                        }
                      })
                    ) : (
                      <div className="selected-plan-private">
                        {this.state.selectedCharger.accessType ===
                          "Private" && (
                          <Translate value="plugInfo_selected_plan_private" />
                        )}
                        {this.state.selectedCharger.accessType ===
                          "FreeCharge" && (
                          <Translate value="plugInfo_selected_plan_free" />
                        )}
                      </div>
                    )}
                    {this.state.selectedCharger !== null && (
                      <>
                        <div className="fleet-title">
                          <Translate value="myChargers_purchaseTariff" />
                        </div>
                        <div className="select-container purchase-tariff">
                          <select
                            defaultValue={this.getPurchaseTariffDefaultValue()}
                            onChange={this.handleOnChangePurchaseTariff}
                          >
                            <option value="" disabled hidden>
                              {I18n.t("plugInfo_noPurchaseTariffSelected")}
                            </option>
                            {this.state.purchaseTariffs.map((pt, idx) => (
                              <option key={pt._id || idx} value={idx}>{pt.name}</option>
                            ))}
                          </select>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  preferences: state.account.preferences,
  accountData: state.account.accountData,
});

export default connect(mapStateToProps, { setAlert })(PlugInfo);
